import './Page.less';

const PageElement = ({ element = '', className = '', children, ...props }) => {
    const classNames = `${element} ${className}`;
    return (
        <div {...props} className={classNames}>
            {children}
        </div>
    );
};

const Page = (props) => <PageElement element="Page" {...props} />;

Page.Header = (props) => <PageElement element="PageHeader" {...props} />;
Page.Header.Left = (props) => <PageElement element="PageHeaderLeft" {...props} />;
Page.Header.Center = (props) => <PageElement element="PageHeaderCenter" {...props} />;
Page.Header.Right = (props) => <PageElement element="PageHeaderRight" {...props} />;

Page.Main = (props) => <PageElement element="PageMain" {...props} />;
Page.Content = (props) => <PageElement element="PageContent" {...props} />;
Page.Row = (props) => <PageElement element="PageRow" {...props} />;
Page.Row.Col = (props) => <PageElement element="PageCol" {...props} />;

Page.Footer = (props) => <PageElement element="PageFooter" {...props} />;
Page.Footer.Left = (props) => <PageElement element="PageFooterLeft" {...props} />;
Page.Footer.Center = (props) => <PageElement element="PageFooterCenter" {...props} />;
Page.Footer.Right = (props) => <PageElement element="PageFooterRight" {...props} />;

export default Page;
